import { Stack } from "@mui/material";
import { ReactComponent as IconLogo } from "assets/images/logo/logo.svg";
import { memo } from "react";

import Navbar from ".";

interface NavbarProps {
  messageBadge?: number;
}

const NavbarContainer = (props: NavbarProps) => {
  const { messageBadge } = props;

  return (
    <Stack direction="column" className="navbar">
      <div className="navbar logo-container">
        <IconLogo className="navbar logo" />
      </div>
      <Navbar messageBadge={messageBadge} />
    </Stack>
  );
};

export default memo(NavbarContainer);
